module.exports = __webpack_public_path__ + "static/emma@2x-583693d001e1ec7484a163a30334274c.png";